/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbBannerUtils } from "abreact/app/banner/AbBannerUtils";
import { AbPopup } from "abreact/incubator/ui/popup/AbPopup";
import { AbPopupContext } from "abreact/incubator/ui/popup/PopupContext";
import { PopupUtils } from "abreact/incubator/ui/popup/PopupUtils";
import { CssUtils } from "abreact/incubator/ui/utils/CssUtils";
import { ProductInfo } from "abweb/dto/product/ProductInfo";
import { AbWebServices } from "abweb/service/AbWebServices";
import { ErrorUtils } from "abweb/utils/ErrorUtils";
import * as React from "react";
export const showSplashDialog = async () => {
  const splashPath = AbBannerUtils.customBrandingPath(ProductInfo.CUSTOM_SPLASH_DIALOG_INFO);
  if (splashPath === null) {
    return Promise.resolve();
  }
  const popup = /*#__PURE__*/React.createElement(AbSplashDialog, {
    src: splashPath
  });
  const popupHandle = PopupUtils.showPopupExplicitly(popup);
  await popupHandle.untilClosed;
};
const AbSplashDialog = props => {
  const iframeRef = React.useRef(null);
  const popupContext = React.useContext(AbPopupContext);
  React.useEffect(() => {
    const iframeWindow = iframeRef.current?.contentWindow ?? ErrorUtils.throw("custom iframe not initialized");
    iframeWindow.okSplashDialog = () => popupContext?.popupHandle.close();
    iframeWindow.cancelSplashDialog = () => AbWebServices.authenticationService.logout();
  }, [popupContext?.popupHandle]);
  return /*#__PURE__*/React.createElement(AbPopup, {
    className: "ab-splash-dialog"
  }, /*#__PURE__*/React.createElement("iframe", {
    style: {
      border: "none"
    },
    src: props.src,
    ref: iframeRef,
    onLoad: e => {
      const popupContentElement = e.currentTarget.ownerDocument.querySelector(".ab-splash-dialog .ab-popup-content") ?? ErrorUtils.throw("popup content not found");
      const contentDocument = e.currentTarget.contentDocument ?? ErrorUtils.throw("iframe content document not found");
      popupContentElement.style.width = CssUtils.stringOrNumberToCssString(contentDocument.body.scrollWidth);
      popupContentElement.style.height = CssUtils.stringOrNumberToCssString(contentDocument.body.scrollHeight);
    }
  }));
};
//# sourceMappingURL=AbSplashDialog.js.map
